import React from 'react';
import classNames from 'classnames';

import CtaButton from 'components/essentials/Cta/CtaButton';

const LoadMoreButton = ({ onClick, disabled = false, isLoading = false }) => (
  <div className="flex justify-center items-center gap-4 cursor-pointer">
    <div className={classNames('flex p-2 relative')}>
      <span className="z-20 bg-white p-[5px] rounded-md">
        <CtaButton
          onClick={onClick}
          isLoading={isLoading}
          styling="outline-button"
          disabled={disabled}
        >
          Load More
        </CtaButton>
      </span>
    </div>
  </div>
);
export default LoadMoreButton;
